import React from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import type {
  MemberInfo,
} from '../types/member.types';

import {
  formatDate,
  formatNumber,
} from '../../../shared/utils/formatUtils';

import StatusBadge from './StatusBadge';

import RouteConfig from '../../../routes/RouteConfig';

type Props = {
  users: MemberInfo[];

  hasActiveFilter:
    boolean;

  onActivate:
    (
      userId: string,
    ) => Promise<void>;

  onDeactivate:
    (
      userId: string,
    ) => Promise<void>;
};

const MemberTable:
  React.FC<Props> = ({
    users,
    hasActiveFilter,
    onActivate,
    onDeactivate,
  }) => {
  const navigate =
    useNavigate();

  return (
    <section className="hidden min-h-0 flex-1 overflow-hidden rounded-xl border border-gray-300 bg-white md:block">
      <div className="h-full overflow-auto">
        <table className="min-w-[1050px] w-full">
          <thead className="sticky top-0 z-10 border-b border-gray-300 bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left">
                회원
              </th>

              <th className="px-4 py-3 text-left">
                라포이트 시드
              </th>

              <th className="px-4 py-3 text-left">
                매장포인트
              </th>

              <th className="px-4 py-3 text-left">
                연락처
              </th>

              <th className="px-4 py-3 text-left">
                가입일
              </th>

              <th className="px-4 py-3 text-left">
                상태
              </th>

              <th className="px-4 py-3 text-left">
                액션
              </th>
            </tr>
          </thead>

          <tbody>
            {users.length ===
            0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-6 py-16 text-center text-gray-500"
                >
                  {hasActiveFilter
                    ? '검색 결과가 없습니다'
                    : '등록된 회원이 없습니다'}
                </td>
              </tr>
            ) : (
              users.map(
                (user) => (
                  <tr
                    key={
                      user.id
                    }
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="px-4 py-4">
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            RouteConfig
                              .Management
                              .MemberDetail
                              .to(
                                user.userId,
                              ),
                          )
                        }
                        className="text-left"
                      >
                        <div className="font-medium text-black hover:text-main">
                          {
                            user.userName
                          }

                          {user.userNickname
                            ? ` (${user.userNickname})`
                            : ''}
                        </div>

                        <div className="mt-1 text-sm text-gray-500">
                          #
                          {
                            user.userId
                          }
                        </div>
                      </button>
                    </td>

                    <td className="px-4 py-4">
                      {formatNumber(
                        user.point ??
                          0,
                      )}
                    </td>

                    <td className="px-4 py-4">
                      {formatNumber(
                        user.storePoint ??
                          0,
                      )}
                    </td>

                    <td className="px-4 py-4">
                      {user.phoneNumber ??
                        '-'}
                    </td>

                    <td className="px-4 py-4">
                      {formatDate(
                        user.createAt,
                      )}
                    </td>

                    <td className="px-4 py-4">
                      <StatusBadge
                        status={
                          user.status
                        }
                      />
                    </td>

                    <td className="px-4 py-4">
                      {user.status ===
                      'ACTIVE' ? (
                        <button
                          type="button"
                          onClick={() =>
                            void onDeactivate(
                              user.userId,
                            )
                          }
                          className="rounded-lg bg-red-500 px-3 py-2 text-sm font-medium text-white hover:bg-red-600"
                        >
                          비활성화
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() =>
                            void onActivate(
                              user.userId,
                            )
                          }
                          className="rounded-lg bg-green-500 px-3 py-2 text-sm font-medium text-white hover:bg-green-600"
                        >
                          {user.status ===
                          'PENDING'
                            ? '승인'
                            : '활성화'}
                        </button>
                      )}
                    </td>
                  </tr>
                ),
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default MemberTable;